export class TCHA {
  constructor(total = 0, count = 0, highest = 0, avg = 0) {
    this.total = total;
    this.highest = highest;
    this.avg = avg;
    this.count = count
  }
}
